import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { OrgRole } from '../lib/api';

const ROLE_LEVEL: Record<OrgRole, number> = {
  member: 0,
  admin:  1,
  owner:  2,
};

interface Props {
  /** Minimum org-level role required to access routes nested under this guard.
   *  R-82: the real enforcement is server-side; this is UI convenience only.  */
  minRole?: OrgRole;
}

export function ProtectedRoute({ minRole = 'member' }: Props) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100dvh',
          color: 'var(--color-text-muted)',
          fontSize: '0.9375rem',
        }}
      >
        Loading…
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/sign-in" replace />;
  }

  if (ROLE_LEVEL[user.role] < ROLE_LEVEL[minRole]) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
